import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-whatsapp-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-whatsapp-svg-icon.component.html',
  styleUrl: './ln-whatsapp-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnWhatsappSvgIconComponent {
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#372121';
}
